import angular from 'angular';

export const CURRENCY_CODES = {
    USD: 'USD',
};

angular
    .module('TALENYA-FE')
    .constant('CURRENCY_CODES', CURRENCY_CODES);
